module.exports = __webpack_public_path__ + "static/img/repair-improve.1b3dd04b.png";